import React from 'react';
import { 
	number, 
	bool,
	func
} from 'prop-types';
import style from './style';

const AnswerCandidateListItem = ({
	index,
	onDelete,
	isAnswer,
	...props}) => {
	return (
		<style.Wrapper 
			isAnswer={isAnswer} 
			{...props}
		>
			<style.Label>
				{(index+1)+'.'}
			</style.Label>
			<style.Text>
				{props.children}
			</style.Text>
			<div>
				{ !isAnswer && (
					<style.IconButton onClick={onDelete}>
						<style.RemoveIcon />
					</style.IconButton>
				)}
			</div>
			
		</style.Wrapper>
	);
};

AnswerCandidateListItem.propTypes = {
	index: number,
	onDelete:func,
	isAnswer:bool
};

export default AnswerCandidateListItem;